import axios from "axios";

const fetchAuditLogs = params => axios.get("api/v1/audit_logs", { params });

const fetchCountries = () => axios.get("neeto_team_members/profile/countries");

const fetchPermissions = () => axios.get("neeto_team_members/permissions");

const auditLogsApi = { fetchAuditLogs, fetchCountries, fetchPermissions };

export default auditLogsApi;
